import React from "./react.shim";
// export interface MainAppContextValue {
//     providerName:'',
//     appEntry:''
// }
const GlobalContext = React.createContext({});
GlobalContext.displayName = "GlobalContext";

export {GlobalContext}
